import Home from 'pages/Home';
import Profile from 'pages/Employee';

const sharedRoutes = [
  { path: '/home', component: Home },
  { exact: true, path: '/employees/profile', component: Profile },
  { exact: true, path: '/profile', component: Profile },
];

export default sharedRoutes;
